import { createTicker } from './createTicker';

export const secondTicker = createTicker(1_000);
